import { KebabMenu, KebabMenuItem } from '@library/components/menus';
import EditIcon from '@library/assets/images/icons/edit-icon.svg';
import TrashIcon from '@library/assets/images/icons/trash-icon.svg';
import { classNames } from '@library/utils';

export interface UserRoleMenuActions {
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
}

export interface UserKebabMenuProps {
  deleteMessage?: string;
  editMessage?: string;
  menuActions: UserRoleMenuActions;
  menuItemsClassName?: string;
  id: string;
}

export const UserKebabMenu = ({
  deleteMessage = 'Deactivate user',
  editMessage = 'Edit user details',
  menuActions,
  menuItemsClassName = '',
  id
}: UserKebabMenuProps) => {
  const { onEdit, onDelete } = menuActions;

  const menuItems = [
    ...(onEdit
      ? [
          {
            handleOnClick: onEdit,
            message: editMessage,
            icon: EditIcon
          }
        ]
      : []),
    ...(onDelete
      ? [
          {
            handleOnClick: onDelete,
            message: deleteMessage,
            icon: TrashIcon
          }
        ]
      : [])
  ];

  const renderMenuItems = () => {
    return menuItems.map((menuItem) => {
      const { handleOnClick, icon, message } = menuItem;
      return (
        <KebabMenuItem
          key={message}
          className="text-soClean-100 hover:bg-soFresh-120 flex h-9 w-full items-center rounded-md px-2"
          handleOnClick={(event) => {
            event.stopPropagation();
            handleOnClick(id);
          }}
        >
          <span>{message}</span>
          <img alt={message} className="ml-auto size-4" src={icon} />
        </KebabMenuItem>
      );
    });
  };

  return (
    <KebabMenu
      className="relative size-6"
      menuButtonClassName="self-center"
      menuItemsClassName={classNames(
        'border border-soFresh-140 bg-soFresh-110 z-10 right-0 text-xs w-40 rounded-md bottom-[-1rem] right-7',
        menuItemsClassName
      )}
      menuButtonOpenClassName="rounded-md bg-soFresh-140"
      title="UserKebabMenu"
      testId={`user-kebab-menu-${id}`}
    >
      <p className="text-soClean-100 cursor-default p-2 font-bold">Actions</p>
      {renderMenuItems()}
    </KebabMenu>
  );
};
